<template>
  <EModal class="feedback-modal" v-bind="$attrs" v-on="$listeners">
    <EFeedbackForm v-bind="$props" @success="onSuccess" />
  </EModal>
</template>

<script>
import { AUTOCLOSE as AUTOCLOSE_TIMEOUT } from '~~/common/js/constants/timeouts';
import '~~/common/vue/directives/validity';
import EFeedbackForm from '~~/common/vue/components/feedback-form';
import EModal from '~~/common/vue/components/modal';

export default {
  name: 'EFeedbackModal',
  components: {
    EModal,
    EFeedbackForm,
  },
  props: EFeedbackForm.props,
  methods: {
    onSuccess() {
      setTimeout(() => {
        this.$emit('close');
      }, AUTOCLOSE_TIMEOUT);
    },
  },
};
</script>

<docs>
A Feedback Modal

### Configuring the endpoint

Use the `url` property to define the disired endpoint.
We usually use [Mercury proxy](https://github.com/ecosia/core/tree/master/mercury).

### States

#### Default
```js
let active = false;
const options = ['I like the feature', 'Something is missing',
  'I don\'t find this useful', 'I don\'t understand this'];

<div>
  <EButton @click="active = true">Show modal</EButton>
  <EFeedbackModal
    :active="active"
    @close="active = false"
    title="What is your feedback?"
    success-title="Thank you for your time?"
    success-message="Your feedback will help us improve ecosia"
    textarea-placeholder="Tell us more (optional)"
    button-text="Send"
    :options="options"
    url="https://httpstat.us/200"
    error-message="Oops, there was an error sending feedback"
  />
</div>
```

#### With subjects
```js
let active = false;
const options = ['I like the feature', 'Something is missing',
  'I don\'t find this useful', 'I don\'t understand this'];
const subjects= ['Log-in feature', 'Personal counter', 'General']
<div>
  <EButton @click="active = true">Show modal</EButton>
  <EFeedbackModal
    :active="active"
    @close="active = false"
    title="What is your feedback?"
    success-title="Thank you for your time?"
    success-message="Your feedback will help us improve ecosia"
    textarea-placeholder="Tell us more (optional)"
    subjects-placeholder="please choose an option"
    button-text="Send"
    :subjects="subjects"
    :options="options"
    url="https://httpstat.us/200"
    error-message="Oops, there was an error sending feedback"
  />
</div>
```

#### With error
```js
let active = false;
const options = ['I like the feature', 'Something is missing',
  'I don\'t find this useful', 'I don\'t understand this'];
const subjects= ['Log-in feature', 'Personal counter', 'General']
<div>
  <EButton @click="active = true">Show modal</EButton>
  <EFeedbackModal
    :active="active"
    @close="active = false"
    title="What is your feedback?"
    success-title="Thank you for your time."
    success-message="Your feedback will help us improve Ecosia."
    textarea-placeholder="Tell us more (optional)"
    subjects-placeholder="please choose an option"
    button-text="Send"
    :subjects="subjects"
    :options="options"
    url="https://httpstat.us/500"
    error-message="Oops, there was an error sending feedback"
  />
</div>
```

</docs>
